import React from "react";
import * as PropTypes from "prop-types";
import Switch from "./Switch";

const AbsoluteValuesSwitch = props => (
  <Switch onText="Absolute" offText="Relative" {...props} />
);

AbsoluteValuesSwitch.propTypes = {
  checked: PropTypes.bool,
  buttonClassName: PropTypes.string,
  onToggle: PropTypes.func.isRequired
};

export default AbsoluteValuesSwitch;
